export class UpdateIngestNodesStatusRequest {
    refineryConfigGuid: string;
    nodeID: string;

    constructor(
        refineryConfigGuid: string,
        nodeID: string
        ) {
        this.refineryConfigGuid = refineryConfigGuid;
        this.nodeID = nodeID;
    }
}